import React, { useState } from "react";
import axios from 'axios';
import './ChangeEmailModal.css';
import { API_BASE_URL} from "../../Variables";

/**
 * Change Email Modal, used to update the user's email address in Settings page
 * @param {*} onClose - Function to close the modal
 * @param {*} refresh - Function to refresh the user settings
 * @returns - JSX element
 */
function ChangeEmailModal({ onClose, refresh }) {
  const [newEmail, setNewEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const token = localStorage.getItem('token');

    /**
   * Validate email format
   * @param {*} email - email to validate
   * @returns - true if email is valid, false otherwise
   */
    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

  const handleEmailChange = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (newEmail !== confirmEmail) {
      setError("Emails do not match");
      return;
    }

    if (!validateEmail(newEmail)) {
      setError('Invalid email format');
      return;
    }

    try {
      // Check if email is unique
      const emailResponse = await axios.get(`${API_BASE_URL}/users/check-email/${newEmail}`);
      if (!emailResponse.data.isUnique) {
        setError('Email is already taken');
        return;
      }

      const response = await axios.put(
        `${API_BASE_URL}/settings/update-email`,
        { newEmail, confirmEmail },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      setSuccessMessage(response.data.message);
      setNewEmail('');
      setConfirmEmail('');
      setError('');
      refresh();
      setTimeout(onClose, 2000);
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to update email');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="change-modal">
        <h2>Change Email</h2>

        {successMessage && <p className="success">{successMessage}</p>}

        <form onSubmit={handleEmailChange}>
          <div className="form-input">
            <label>New Email:</label>
            <input type="email" value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)} required/>
          </div>

          <div className="form-input">
            <label>Confirm Email:</label>
            <input type="email" value={confirmEmail}
              onChange={(e) => setConfirmEmail(e.target.value)} required/>
          </div>

          {error && <p className="error">{error}</p>}

          <button type="submit" className="tertiary-button">Update Email</button>
          <button type="button" onClick={onClose} className="secondary-button">Cancel</button>
        </form>
      </div>
    </div>
  );
}

export default ChangeEmailModal;